try {
  const rebuyInterval = setInterval(rebuy, 1000);

  function rebuy() {
    const arrow_prev = document.querySelector('.splide__arrow--prev');
    const arrow_next = document.querySelector('.splide__arrow--next');
    if(arrow_prev) {
      arrow_prev.setAttribute('aria-label', 'rebuy-arrow-previous');
      let div = document.createElement("div");
      div.className = "visually-hidden";
      div.textContent = "arrow-previous";
      arrow_prev.prepend(div);
    }
    if(arrow_next) {
      arrow_next.setAttribute('aria-label', 'rebuy-arrow-next');
      let div = document.createElement("div");
      div.className = "visually-hidden";
      div.textContent = "arrow-next";
      arrow_next.prepend(div);
      stop();
    }
  }
  function stop() {
    clearInterval(rebuyInterval);
  }
}
catch(error) {
  console.log('error');
}